import { STORAGE_KEYS } from '@app/domain/ports';

const SECONDARY_METADATA_KEY_LIST = [
  STORAGE_KEYS.DEK_RAW,
  STORAGE_KEYS.DEK_WRAPPED_BY_PIN,
  STORAGE_KEYS.DEK_WRAPPED_BY_PASSWORD,
  STORAGE_KEYS.DEK_WRAPPED_BY_WEBAUTHN,
  STORAGE_KEYS.PASSWORD_ENCRYPTED_BY_DEK,
  STORAGE_KEYS.USER_PROFILE,
] as const;

const SECONDARY_METADATA_KEYS = new Set<string>(SECONDARY_METADATA_KEY_LIST);

export const isSecondaryMetadataKey = (key: string): boolean => SECONDARY_METADATA_KEYS.has(key);
